import React from 'react';

import {
  BoxProps, Flex, Td, ThemingProps,
} from '@chakra-ui/react';
import dayjs from 'dayjs';
import { UseFormReturn } from 'react-hook-form';

import { StatusBadge } from 'components';

import { PartnerBadge } from './Badge';
import { Default } from './Default';
import { Frequency } from './Frequency';
import { Images } from './Images';
import Rules from './Rules';

type Variants = ThemingProps<'Text'>['variant']

interface ItemProps extends BoxProps {
  type?: string
  form?: UseFormReturn
  editable?: boolean
  options?: string[]
  id: string
  item: any
  original: any
  variant: Variants
  formatter?: (_: any) => string
}

const Item = ({
  type = 'text',
  id,
  item,
  original,
  variant,
  form,
  editable,
  formatter = (_value: any) => _value,
  ...rest
}: ItemProps) => {
  const children = {
    text: <Default
      id={id}
      value={formatter(item)}
      variant={variant}
    />,
    date: <Default
      id={id}
      value={dayjs(item).format('DD/MM/YYYY')}
      variant={variant}
    />,
    rule: <Rules
      editable={editable}
      id={`permissions.${original.key}.${id}`}
      value={item}
      {...form}
    />,
    temperature: <Default
      id={id}
      value={item}
      suffix="ºC"
      variant={variant}
    />,
    weight: <Default
      id={id}
      value={Number(item).toFixed(2)}
      suffix="Kg"
      variant={variant}
    />,
    status: <StatusBadge
      status={item}
      minH={6}
      justifyContent="center"
      small
    />,
    partner: <PartnerBadge
      value={item}
      variant={variant}
    />,
    frequency: <Frequency
      original={original}
      value={item}
      variant={variant}
    />,
    images: <Images
      value={item}
    />,
  }[type];

  return (
    <Td
      color="gray.500"
      align="left"
      {...rest}
      p={4}
      w="min">
      <Flex>{children}</Flex>
    </Td>
  );
};

export default Item;
